module.exports = __webpack_public_path__ + "media/icons/dots-loading-f0486ef3.gif";